import { createContext, useContext } from "react";

// Context for tracking current selections (optimistic UI)
interface SelectedOptionsContextType {
  selectedOptionIds: string[];
  setSelectedOptionIds: (ids: string[]) => void;
}

export const SelectedOptionsContext = createContext<
  SelectedOptionsContextType | undefined
>(undefined);

export const useSelectedOptions = () => {
  const context = useContext(SelectedOptionsContext);
  if (!context) {
    throw new Error(
      "useSelectedOptions must be used within SelectedOptionsProvider",
    );
  }
  return context;
};
